import React from "react";

const TerminalNull = () => {
  return <div />;
};

export default TerminalNull;
